<template>
    <div class='pg-info'>
        <div class="input-mod">
            <div class="input-item">
                <div class="label">Name: </div>
                <input type="text" v-model="info.name">
            </div>
            <div class="input-item">
                <div class="label">Job: </div>
                <input type="text" v-model="info.job">
            </div>
            <div class="input-item">
                <div class="label">Age: </div>
                <input type="text" v-model="info.age">
            </div>
            <div class="input-item">
                <div class="label">Education: </div>
                <input type="text" v-model="info.edu">
            </div>
            <div class="input-item">
                <div class="label">Address: </div>
                <input type="text" v-model="info.addr">
            </div>
        </div>
        <van-button class="save-btn" block round type="info" @click="_save">Confirm</van-button>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {cloneDeep} from 'lodash';
import config from '../config';

export default {
    name: 'Info',
    data(){
        return {
            info: {}
        }
    },
    computed: {
        ...mapState(['userInfo','lang']),
    },
    watch: {
        userInfo: {
            handler(val){
                this.info = cloneDeep(val.info)
            },
            immediate: true
        }
    },
    created(){

    },
    methods: {
        ...mapActions(['setUserInfo']),
        _save(){
            Utils.$ajax({
                type: 'post',
                url: '/user/updata',
                data: this.info
            }).done(res=>{
                if(res.code != 0){
                    this.$toast(res.msg);
                    return;
                }
                this.$toast(res.msg);
                this.setUserInfo(res.data);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .pg-info{
        color: #fff;
    }
    .input-mod{
        margin-top: rem(100);
    }
    .input-item{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: rem(30) 0;
        padding: 0 rem(70);

        input{
            width: rem(400);
            height: rem(70);
            flex-shrink: 0;
            margin-left: rem(20);
            background: #fff;
            color: #333;
        }
        .label{
            font-size: rem(30);
        }
    }
    .save-btn{
        width:70%;
        margin: rem(100) auto 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Info.vue